module.exports = __webpack_public_path__ + "img/convenio-de-practicas8.dd961551.png";